import React from 'react';
import { CountdownBar } from './components/CountdownBar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { BenefitsSection } from './components/BenefitsSection';
import { BonusSection } from './components/BonusSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GallerySection } from './components/GallerySection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <main className="min-h-screen w-full font-sans" data-id="element-0">
      <CountdownBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <PainSection data-id="element-3" />
      <SolutionSection data-id="element-4" />
      <BenefitsSection data-id="element-5" />
      <BonusSection data-id="element-6" />
      <TestimonialsSection data-id="element-7" />
      <GallerySection data-id="element-8" />
      <PricingSection data-id="element-9" />
      <GuaranteeSection data-id="element-10" />
      <FAQSection data-id="element-11" />
      <SocialProofPopup data-id="element-12" />
    </main>;
}